import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { UserTemporaryRequestBody, UserTemporaryResponse } from "./types";

export class UserTemporaryAPI extends BaseAPI<
  UserTemporaryRequestBody,
  UserTemporaryResponse
> {
  protected route = ApiRoutes.auth.temporary;
  protected method = RequestMethod.POST;
}
